import React, { lazy, Suspense } from 'react'
import { Box } from '@material-ui/core'
import { BrowserRouter, Route, Switch, Redirect, useLocation } from 'react-router-dom'
import Loading from './shared/components/Loading'
import useSpreadsheet from './core/services/googleSpreadsheetToJson/hooks'
import PrivateRoute from './shared/components/PrivateRoute'
import Pages from './pages'
import { AlertUnauthContext } from './pages/model'
import { useAlertMachine } from './shared/machine/alertMachine/hooks'
import Alert from './shared/components/Alert'
import CartProvider from './shared/components/CartProvider'
import storeV1 from './reducers/configureStore'
import store from './reducers/store'
import { Provider } from 'react-redux'
// import useGetAccountPermission from './shared/services/getAccountPermission/hooks'

const Login = lazy(() => import('./login'))
const BackLogin = lazy(() => import('./back_login'))
const Reset = lazy(() => import('./reset'))
const SimulationV1 = lazy(() => import('./simulationV1'))
const SimulationV2 = lazy(() => import('./simulationV2'))
const SimulationAdaptation2 = lazy(() => import('./simulationAdaptation2'))
const AccountManage = lazy(() => import('./pages/AccountManage'))

const Cart = lazy(() => import('./pages/Cart'))

export function ScrollToTop() {
  const { pathname } = useLocation()
  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])
  return null
}

const App: React.FC = () => {
  const { openAlert, closeAlert, isAlertOpen, alertMessage } = useAlertMachine()
  const { isFetched } = useSpreadsheet()
  const hasPermission = window.localStorage.getItem('ACCESS_TOKEN')
  // const { data: permission } = useGetAccountPermission(!!hasPermission)
  // const hasAccQry = permission?.data.result_data.premissions.includes('acc:qry')
  const doCloseAlert = () => {
    closeAlert()
    alertMessage.onClose && alertMessage.onClose()
  }

  React.useEffect(() => {
    setTimeout(() => {
      const consultBtn = document.querySelector<HTMLElement>('.woot-widget-bubble.woot-elements--right')
      if (consultBtn) {
        consultBtn.setAttribute('style', 'z-index: 1500 !important')
      }
    }, 1500)
  }, [])

  return isFetched ? (
    <BrowserRouter>
      <ScrollToTop />
      <Box>
        <Alert
          isDicidedMode={alertMessage.isDicidedMode as boolean}
          onClose={doCloseAlert}
          open={isAlertOpen}
          title={alertMessage.title}
          content={alertMessage.content}
        />
        <Suspense fallback={<Loading />}>
          <AlertUnauthContext.Provider value={openAlert}>
            <CartProvider>
              <Switch>
                {!hasPermission && (
                  <Route strict sensitive path='/login'>
                    <Login />
                  </Route>
                )}
                {!hasPermission && (
                  <Route strict sensitive path='/back_login'>
                    <BackLogin />
                  </Route>
                )}
                <PrivateRoute path='/pages/cart'>
                  <Cart />
                </PrivateRoute>

                <PrivateRoute path='/account-management'>
                  <AccountManage />
                </PrivateRoute>

                <PrivateRoute strict sensitive path='/pages'>
                  <Pages />
                </PrivateRoute>
                <PrivateRoute strict sensitive path='/simulationV1'>
                  <Provider store={storeV1}>
                    <SimulationV1 />
                  </Provider>
                </PrivateRoute>
                <PrivateRoute strict sensitive path='/simulationV2'>
                  <Provider store={storeV1}>
                    <SimulationV2 />
                  </Provider>
                </PrivateRoute>
                <PrivateRoute strict sensitive path='/simulation-adaptation'>
                  <Provider store={store}>
                    <SimulationAdaptation2 />
                  </Provider>
                </PrivateRoute>
                <Route strict sensitive path='/reset'>
                  <Reset />
                </Route>
                <Redirect push from='/' to='/pages' />
              </Switch>
            </CartProvider>
          </AlertUnauthContext.Provider>
        </Suspense>
      </Box>
    </BrowserRouter>
  ) : (
    <Loading />
  )
}

export default App
